var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgComputer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 265"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 264"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.01521 55.6187V57.6235C2.01521 57.9682 2.25108 58.2676 2.5958 58.3492L40.8238 67.3483C42.248 67.684 43.7449 67.6023 45.1238 67.1215L65.6439 59.9549C66.0158 59.8279 66.2607 59.4741 66.2607 59.084V57.3241",
    stroke: "#EF9071",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M30.1466 51.9532C30.1466 51.9532 28.2234 51.7174 27.7789 51.672C27.3435 51.6176 27.035 51.6992 25.892 51.8172C24.749 51.926 2.18775 55.464 2.1061 55.4912C2.02446 55.5184 1.88838 55.7361 2.1696 55.7996C2.45083 55.8631 40.2797 63.7918 40.7151 63.8462C41.1505 63.9006 42.0668 64.1456 43.1191 64.0911C44.1714 64.0367 45.1058 63.6557 45.8769 63.447C46.648 63.2293 65.6078 57.4597 65.9888 57.3237C66.3698 57.1876 66.7599 56.9517 65.5261 56.8156C64.2833 56.6796 61.1899 56.226 61.1899 56.226L30.1466 51.9532Z",
    stroke: "#EF9071",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M65.8889 57.351C65.8889 57.351 66.8958 57.1061 66.9412 56.1807C66.9865 55.2464 69.0186 22.1711 69.0639 21.5542C69.1093 20.9464 68.8099 20.1118 67.9753 20.003C67.1407 19.8941 30.9176 22.8333 30.3914 22.8424C29.8562 22.8605 29.5115 23.3958 29.4026 24.0671C29.2938 24.7384 27.552 50.9464 27.5339 51.2276C27.5157 51.5088 27.7062 51.654 27.7062 51.654",
    stroke: "#EF9071",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M32 47.8769L62.3824 51.5488L64 25.5488L33.4378 27.473L32 47.8769Z",
    stroke: "#EF9071",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputer);
export default __webpack_public_path__ + "static/media/computer.bdd78cae1c878811f7dc86b4ad703720.svg";
export { ForwardRef as ReactComponent };